import { Card, CardBody, Col, } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Disable } from "../../../../Constant";
import DisabledForm from "./DisabledForm";

const Disabled = () => {
    
    return (
      <Col lg="6">
        <Card>
          <CommonCardHeader title={Disable}/>
          <CardBody>
          <DisabledForm/>
          </CardBody>
        </Card>
      </Col>
    );
};

export default Disabled;
